module.exports = __webpack_public_path__ + "images/user-white-placeholder.6f5ad60f.png";